var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutomation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.730469,
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_182_1469)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_182_1469)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4951 12.1414L24.4957 12.157C24.5403 14.5062 24.5957 17.4299 23.6157 20.0867C23.0785 21.5436 22.2655 22.81 21.1995 23.8511C19.986 25.0363 18.3967 25.9778 16.4761 26.6494C16.4132 26.6714 16.3478 26.6893 16.2816 26.7025C16.1883 26.7212 16.0942 26.7305 16.0002 26.7305C15.9062 26.7305 15.8122 26.7212 15.7188 26.7025C15.6526 26.6893 15.5876 26.6716 15.525 26.6497C13.6021 25.9793 12.0112 25.0383 10.7966 23.853C9.73017 22.8122 8.91717 21.546 8.38037 20.0894C7.40411 17.4406 7.45965 14.5224 7.50436 12.1776L7.50527 12.1414C7.51397 11.9479 7.51992 11.7447 7.52328 11.5201C7.5396 10.4172 8.41638 9.50501 9.51914 9.44351C11.8186 9.31504 13.5975 8.56522 15.1175 7.08375L15.1304 7.07139C15.6263 6.61683 16.3742 6.61683 16.8699 7.07139L16.8829 7.08375C18.4028 8.56522 20.1817 9.31504 22.4812 9.44336C23.5841 9.50501 24.4608 10.4172 24.4771 11.5199C24.4806 11.7461 24.4864 11.9493 24.4951 12.1414ZM16.8293 12.076C16.7234 11.8642 16.507 11.7305 16.2703 11.7305C16.0335 11.7305 15.8171 11.8642 15.7112 12.076L11.9255 19.6474C11.7711 19.9562 11.8963 20.3316 12.205 20.486C12.5138 20.6403 12.8892 20.5152 13.0436 20.2064L14.322 17.6496H18.2185L19.497 20.2064C19.6514 20.5152 20.0268 20.6403 20.3355 20.486C20.6443 20.3316 20.7694 19.9562 20.6151 19.6474L16.8293 12.076ZM16.2703 13.7531L17.5935 16.3995H14.9471L16.2703 13.7531Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_182_1469",
    x1: 16,
    y1: 0.730469,
    x2: 16,
    y2: 32.7305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37B06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#199251"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_182_1469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6.73047)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomation);
export default __webpack_public_path__ + "static/media/automation.0aae08544f62fdbe97138264fbf27063.svg";
export { ForwardRef as ReactComponent };